import { useEffect, useState } from 'react'
import './ConfettiBurst.css'

const COLORS = ['#ff6b6b', '#feca57', '#48dbfb', '#ff9ff3', '#54a0ff', '#5f27cd', '#00d2d3', '#2ecc71', '#e056fd']

export function ConfettiBurst({ onDone }) {
  const [particles] = useState(() =>
    Array.from({ length: 55 }, () => {
      const angle = Math.random() * Math.PI * 2
      const dist = 60 + Math.random() * 100
      return {
        x: 50 + (Math.random() - 0.5) * 30,
        y: 50,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        rotation: Math.random() * 360,
        size: 4 + Math.random() * 8,
        delay: Math.random() * 0.3,
        duration: 1.2 + Math.random() * 0.8,
        tx: Math.cos(angle) * dist,
        ty: 40 + Math.random() * 80,
      }
    })
  )

  useEffect(() => {
    const t = setTimeout(() => onDone?.(), 2500)
    return () => clearTimeout(t)
  }, [onDone])

  return (
    <div className="confetti-burst" role="presentation" aria-hidden>
      {particles.map((p, i) => (
        <span
          key={i}
          className="confetti-particle"
          style={{
            '--x': `${p.x}%`,
            '--y': `${p.y}%`,
            '--color': p.color,
            '--rot': `${p.rotation}deg`,
            '--size': `${p.size}px`,
            '--delay': `${p.delay}s`,
            '--duration': `${p.duration}s`,
            '--tx': `${p.tx}px`,
            '--ty': `${p.ty}px`,
          }}
        />
      ))}
    </div>
  )
}
